module.exports = __webpack_public_path__ + "img/QOOKER_Box13.115756a5.jpg";